import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./style";
import { daRoles, daScheduleRoleIdToKey, daScheduleRoleKeyToId } from "mocks/roleDA";
import { CalendarData } from "types/DaHome";
import { useScheduleCellTheme } from "hooks/useTheme";

interface PropsType {
  scheduleData: CalendarData | undefined;
}

const CalendarSmallDetails: FC<PropsType> = ({ scheduleData }) => {
  const classes = useStyles();
  const { theme } = useScheduleCellTheme(scheduleData);

  return (
    <>
      {scheduleData && (
        <Box className={classes.detailsBox}>
          <Box className={`${classes.smallRoleBox} ${theme.backgroundClass}`}>
            <Typography className={`${theme.colorClass} ${classes.smallRoleText}`}>
              {returnRole(scheduleData?.role)}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

const returnRole = (role: number | undefined) => {
  if (role === undefined) return "Available";
  if (
    role === daScheduleRoleKeyToId.mycuCancelled ||
    role === daScheduleRoleKeyToId.clientCancelled
  )
    return "Cancelled";
  return daRoles[daScheduleRoleIdToKey[role]]?.name || "Available";
};

export default CalendarSmallDetails;
